import { Navbar } from "../shared/components/Navbar.js";
import { AuthService } from "../shared/services/AuthService.js";
import { ApiService } from "../shared/services/ApiService.js";
import { AppConfig } from "../shared/config/AppConfig.js";
import { AdjuntosService } from "../shared/services/AdjuntosService.js";

import { TemplateEngine } from "../shared/utils/TemplateEngine.js";
import maintenanceTemplate from "./templates/maintenance.html?raw";
import maintenanceListadoTemplate from "./templates/maintenanceListadoTemplate.html?raw";
import updateKmModalTemplate from "./templates/update-km-modal.html?raw";
import Swal from "sweetalert2";

export const MaintenanceController = {

	siteNamePublicidad: AppConfig.app.name,
	seccionPublicidad: "mantenimiento",
	_maintenanceTypes: [],

	getHiddenKey: (dominio) => `mant_hidden_${dominio}`,

	getHiddenMaintenances: (dominio) =>
		JSON.parse(localStorage.getItem(MaintenanceController.getHiddenKey(dominio)) || '[]'),

	saveHiddenMaintenances: (dominio, hiddenIds) =>
		localStorage.setItem(MaintenanceController.getHiddenKey(dominio), JSON.stringify(hiddenIds)),

	getVisibleMaintenances: (vehicle, maintenanceTypes, vehicleMaintenance) => {
		const hiddenIds = MaintenanceController.getHiddenMaintenances(vehicle.Dominio);
		const visibleTypes = maintenanceTypes.filter(t => !hiddenIds.includes(String(t.Id)));
		return MaintenanceController.calculateMaintenanceStatus(vehicle, visibleTypes, vehicleMaintenance);
	},

	render: async () => {
		try {
			// Preservar estado de tarjetas expandidas antes de re-render
			const expandedVehicles = new Set(
				[...document.querySelectorAll('.vehicle-maintenance-card:not(.collapsed)')]
					.map(c => c.dataset.vehicleId)
			);

			const user = AuthService.getCurrentUser();

			const [vehiclesResponse, tiposMantResp, mantVehiculosResp, adsHeader, adsMedio] = await Promise.all([
				ApiService.post("apiapp/ObtenerVehiculos", null, user?.token),
				ApiService.post("apiapp/TiposMantenimiento", null, user?.token),
				ApiService.post("apiapp/MantenimientoVehiculos", null, user?.token),
				ApiService.get(`apiapp/obtenerpublicidad?sector=1&seccion=${MaintenanceController.seccionPublicidad}&sitio=${MaintenanceController.siteNamePublicidad}&cantidad=1`),
				ApiService.get(`apiapp/obtenerpublicidad?sector=2&seccion=${MaintenanceController.seccionPublicidad}&sitio=${MaintenanceController.siteNamePublicidad}&cantidad=4`),
			]);

			const vehicles = vehiclesResponse.vehiculos;
			const maintenanceTypes = tiposMantResp.message;
			const vehicleMaintenance = mantVehiculosResp.message;

			MaintenanceController._maintenanceTypes = maintenanceTypes;

			const adsHeaderItem = (adsHeader.ads || []).length > 0 ? adsHeader.ads[0].item : null;

			// Calcular resumen
			let criticalCount = 0;
			let warningCount = 0;
			let okCount = 0;
			let noRegistradoCount = 0;

			// Procesar cada vehículo con sus mantenimientos
			const vehiclesWithMaintenance = vehicles.map((vehicle) => {
				const maintenances = MaintenanceController.getVisibleMaintenances(
					vehicle,
					maintenanceTypes,
					vehicleMaintenance,
				);

				maintenances.forEach((m) => {
					if (m.statusClass === "critical") criticalCount++;
					else if (m.statusClass === "warning") warningCount++;
					else if (m.statusClass === "ok") okCount++;
					else if (m.statusClass === "noregistrado") noRegistradoCount++;
				});

				console.log(`Vehicle ${vehicle.Dominio} maintenances:`, maintenances);
				const content = TemplateEngine.render(maintenanceListadoTemplate, { maintenances });

				return {
					...vehicle,
					currentKm: vehicle.Kilometraje.toLocaleString(),
					maintenances: content,
					hasMaintenances: maintenances.length > 0,
					hasCritical: maintenances.some(m => m.statusClass === 'critical'),
				};
			});



			const data = {
				vehicles: vehiclesWithMaintenance,
				criticalCount,
				warningCount,
				okCount,
				noRegistradoCount,
				noVehicles: vehicles.length === 0,
				adsHeader: adsHeaderItem,
				adsMedio: adsMedio.ads,
			};

			console.log("Data to render:", data);
			// console.log("Vehicle 0:", data.vehicles[0])
			//  console.log("Maintenances:", data.vehicles[0]?.maintenances)


			const content = TemplateEngine.render(maintenanceTemplate, data);
			document.getElementById("app").innerHTML = await Navbar.render() + content;

			// Configurar filtros
			MaintenanceController.setupFilters();
			MaintenanceController.setupCollapse();

			// Restaurar tarjetas que estaban expandidas
			expandedVehicles.forEach(vehicleId => {
				const card = document.querySelector(`.vehicle-maintenance-card[data-vehicle-id="${vehicleId}"]`);
				if (card) card.classList.remove('collapsed');
			});

			// Configurar botón de agregar mantenimiento
			//document.getElementById("addMaintenanceBtn").addEventListener("click", MaintenanceController.showAddMaintenanceModal);

			document.querySelectorAll(".btnActualizarKm").forEach((btn) => {
				btn.addEventListener("click", (event) => {
					const vehicleIdReal = event.currentTarget.dataset.idreal;
					const kilometers = event.currentTarget.dataset.kmreal;
					const kmMes = event.currentTarget.dataset.kmmes;
					const Dominio = event.currentTarget.dataset.dominio;
					MaintenanceController.updateVehicleKm(vehicleIdReal, kilometers, kmMes, Dominio);
				});
			});
			document.querySelectorAll(".btnVerHistorial").forEach((btn) => {
				btn.addEventListener("click", (event) => {
					const dominio = event.currentTarget.dataset.dominio;
					MaintenanceController.viewMaintenanceHistory(dominio);
				});
			});

			document.querySelectorAll(".btnMarcarRealizado").forEach((btn) => {
				btn.addEventListener("click", (event) => {
					const Dominio = event.currentTarget.dataset.dominio;
					const maintenanceTypeId = event.currentTarget.dataset.maintenanceTypeId;
					const maintenanceName = event.currentTarget.dataset.maintenancename;
					const kilometrosVehiculo = event.currentTarget.dataset.kmvehiculo;
					MaintenanceController.markMaintenanceDone(Dominio, maintenanceTypeId, maintenanceName, kilometrosVehiculo);
				});
			});

			document.querySelectorAll(".btnProgramarServicio").forEach((btn) => {
				btn.addEventListener("click", (event) => {
					const vehicleId = event.currentTarget.dataset.vehicleId;
					const maintenanceTypeId = event.currentTarget.dataset.maintenanceTypeId;
					MaintenanceController.scheduleService(vehicleId, maintenanceTypeId);
				});
			});

			document.querySelectorAll(".btnOcultarMantenimiento").forEach((btn) => {
				btn.addEventListener("click", (e) => {
					e.stopPropagation();
					const dominio = btn.dataset.dominio;
					const typeId = String(btn.dataset.maintenanceTypeId);
					const hidden = MaintenanceController.getHiddenMaintenances(dominio);
					if (!hidden.includes(typeId)) hidden.push(typeId);
					MaintenanceController.saveHiddenMaintenances(dominio, hidden);
					Swal.fire({
						toast: true,
						position: 'bottom-end',
						icon: 'info',
						title: 'Mantenimiento ocultado',
						text: 'Usá "Personalizar" para mostrarlo o cambiarlo.',
						showConfirmButton: false,
						timer: 3500,
						timerProgressBar: true,
					});
					MaintenanceController.render();
				});
			});

			document.querySelectorAll(".btnPersonalizarMantenimientos").forEach((btn) => {
				btn.addEventListener("click", (e) => {
					e.stopPropagation();
					MaintenanceController.showCustomizeModal(btn.dataset.dominio);
				});
			});

		} catch (error) {
			console.error("Error loading maintenance:", error);
			document.getElementById("app").innerHTML =
				Navbar.render() +
				`<div class="container mt-4">
          <div class="alert alert-danger">Error al cargar los mantenimientos</div>
        </div>`;
		}
	},

	calculateMaintenanceStatus: (vehicle, maintenanceTypes, vehicleMaintenance) => {
		const currentDate = new Date();
		const results = [];
		const TipoAmbos = 2;
		const TipoDistancia = 1;
		const TipoTiempo = 0;

		maintenanceTypes.forEach((type) => {
			const lastMaintenance = vehicleMaintenance.find(
				(vm) => vm.Dominio === vehicle.Dominio && vm.IdTipoMantenimiento === type.Id,
			);

			let status = "ok";
			let statusText = "Al día";
			let statusIcon = "fa-check";
			let dueKm = null;
			let dueDate = null;
			let daysRemaining = null;

			// ✅ Si no existe mantenimiento previo
			if (!lastMaintenance) {
				status = "noregistrado";
				statusText = "No registrado";
				statusIcon = "fa-circle-question";
				results.push({
					maintenanceTypeId: type.Id,
					Dominio: vehicle.Dominio,
					name: type.Nombre,
					description: type.Descripcion,
					icon: type.Icono,
					statusClass: status,
					statusText: statusText,
					statusIcon: statusIcon,
					dueKm: null,
					dueDate: "Programar",
					daysRemaining: null,
					lastPerformed: null,
					lastPerformedKm: null,
					kilometrosVehiculo: vehicle.Kilometraje,
				});
				return; // ⬅️ Saltamos el resto de la iteración
			}

			const FechaUltMantenimiento = lastMaintenance?.Fecha
				? new Date(parseInt(lastMaintenance.Fecha.match(/\d+/)[0], 10))
				: null;

			if (type.Tipo === TipoDistancia || type.Tipo === TipoAmbos) {
				const lastKm = lastMaintenance?.KM || 0;
				const nextKm = lastKm + type.IntervaloKM;
				const kmRemaining = nextKm - vehicle.Kilometraje;

				dueKm = `${nextKm.toLocaleString()} km`;

				if (vehicle.KmMensuales > 0) {
					const monthsRemaining = kmRemaining / vehicle.KmMensuales;
					daysRemaining = Math.round(monthsRemaining * 30);
				}

				if (kmRemaining <= 0) {
					status = "critical";
					statusText = "Vencido";
					statusIcon = "fa-exclamation-triangle";
				} else if (kmRemaining <= type.IntervaloKM * 0.1) {
					status = "warning";
					statusText = "Próximo";
					statusIcon = "fa-exclamation-circle";
				}

			}

			if (type.Tipo === TipoTiempo || type.Tipo === TipoAmbos) {
				if (FechaUltMantenimiento) {
					const lastDate = FechaUltMantenimiento;
					const nextDate = lastDate;
					nextDate.setMonth(nextDate.getMonth() + type.IntervaloMeses);

					const daysDiff = Math.ceil((nextDate - currentDate) / (1000 * 60 * 60 * 24));
					daysRemaining = daysDiff;

					dueDate = nextDate.toLocaleDateString("es-AR");

					if (daysDiff <= 0) {
						status = "critical";
						statusText = "Vencido";
						statusIcon = "fa-exclamation-triangle";
					} else if (daysDiff <= 30) {
						if (status !== "critical") {
							status = "warning";
							statusText = "Próximo";
							statusIcon = "fa-exclamation-circle";
						}
					}
				} else {
					status = "warning";
					statusText = "Sin registro";
					statusIcon = "fa-question-circle";
					dueDate = "Programar";
				}
			}

			if (type.Tipo === TipoAmbos) {
				statusText = status === "critical" ? "Vencido" : status === "warning" ? "Próximo" : "Al día";
			}




			results.push({
				maintenanceTypeId: type.Id,
				Dominio: vehicle.Dominio,
				name: type.Nombre,
				description: type.Descripcion,
				icon: type.Icono,
				statusClass: status,
				statusText: statusText,
				statusIcon: statusIcon,
				dueKm: dueKm,
				dueDate: dueDate,
				daysRemaining: daysRemaining > 0 ? daysRemaining : null,
				lastPerformed: FechaUltMantenimiento
					? FechaUltMantenimiento.toLocaleDateString("es-AR")
					: null,
				lastPerformedKm: lastMaintenance?.KM ? lastMaintenance.KM.toLocaleString() : null,
			});
		});

		return results.sort((a, b) => {
			const priority = { critical: 0, warning: 1, ok: 2 };
			return priority[a.statusClass] - priority[b.statusClass];
		});
	},

	setupCollapse: () => {
		document.querySelectorAll('.vehicle-header').forEach(header => {
			header.addEventListener('click', (e) => {
				if (e.target.closest('button')) return;
				const vehicleId = header.dataset.collapseVehicle;
				const card = document.querySelector(`.vehicle-maintenance-card[data-vehicle-id="${vehicleId}"]`);
				card.classList.toggle('collapsed');
			});
		});
	},

	setupFilters: () => {
		const searchInput = document.getElementById("searchVehicle");
		const statusFilter = document.getElementById("filterStatus");
		const typeFilter = document.getElementById("filterType");

		if (searchInput) {
			searchInput.addEventListener("input", MaintenanceController.applyFilters);
		}
		if (statusFilter) {
			statusFilter.addEventListener("change", MaintenanceController.applyFilters);
		}
		if (typeFilter) {
			typeFilter.addEventListener("change", MaintenanceController.applyFilters);
		}
	},

	applyFilters: () => {
		const searchTerm = document.getElementById("searchVehicle")?.value.toLowerCase() || "";
		const statusFilter = document.getElementById("filterStatus")?.value || "";
		const typeFilter = document.getElementById("filterType")?.value || "";

		const vehicleCards = document.querySelectorAll(".vehicle-maintenance-card");

		vehicleCards.forEach((card) => {
			const vehicleText = card.textContent.toLowerCase();
			const matchesSearch = vehicleText.includes(searchTerm);

			let matchesStatus = true;
			if (statusFilter) {
				const rows = card.querySelectorAll(`.maintenance-row.${statusFilter}`);
				matchesStatus = rows.length > 0;
			}

			const shouldShow = matchesSearch && matchesStatus;
			card.style.display = shouldShow ? "block" : "none";
		});
	},

	updateVehicleKm: async (vehicleIdReal, currentKm, kmMes, Dominio) => {
		try {
			const data = {
				vehicleIdReal,
				currentKm,
				kmMes,
				Dominio,
			};

			const modalContent = TemplateEngine.render(updateKmModalTemplate, data);

			const result = await Swal.fire({
				title: '<i class="fas fa-tachometer-alt me-2"></i>Actualizar Kilometraje',
				html: modalContent,
				width: 600,
				showCancelButton: true,
				confirmButtonText: "Actualizar",
				cancelButtonText: "Cancelar",
				preConfirm: () => {
					const form = document.getElementById("updateKmForm");
					const formData = new FormData(form);
					const newKm = Number.parseInt(formData.get("newKm"));
					const kmMes = Number.parseInt(formData.get("kmMes"));

					if (newKm < currentKm) {
						Swal.showValidationMessage(`El kilometraje debe ser mayor o igual a ${currentKm} km`);
						return false;
					}

					return {
						IdVehiculo: vehicleIdReal,
						Dominio: Dominio,
						Kilometraje: newKm,
						KmMensuales: kmMes,
					};
				},
			});

			if (result.isConfirmed) {

				const user = AuthService.getCurrentUser();

				await ApiService.post("apiapp/VehiculoActualizarKM", result.value, user?.token);

				await Swal.fire({
					title: "¡Actualizado!",
					html: `
						<div class="text-center">
						<i class="fas fa-check-circle text-success mb-3" style="font-size: 3rem;"></i>
						<h5>Kilometraje actualizado correctamente</h5>
						<p class="text-muted">Los recordatorios de mantenimiento se han recalculado</p>
						<div class="mt-3">
							<strong>${Dominio}</strong><br>
							<p class="text-primary fs-5">${result.value.Kilometraje.toLocaleString()} km</p>
							<p class="text-secondary fs-5">${result.value.KmMensuales.toLocaleString()} km/mes</p>
						</div>
						</div>
					`,
					icon: "success",
					confirmButtonText: "Cerrar",
				});
				MaintenanceController.render();
			}
		} catch (error) {
			console.error("Error updating vehicle km:", error);
			Swal.fire("Error", "No se pudo actualizar el kilometraje", "error");
		}
	},

	markMaintenanceDone: async (Dominio, maintenanceTypeId, maintenanceName, kilometrosVehiculo) => {
		try {

			const result = await Swal.fire({
				title: "Marcar como Realizado",
				html: `
          <div class="text-start">
            <p>¿Confirmas que realizaste el siguiente mantenimiento?</p>
            <div class="alert alert-info">
              <strong>${maintenanceName}</strong><br>
              <small>Vehiculo ${Dominio.toUpperCase()}</small>
            </div>
            <div class="mb-3">
              <label class="form-label">Fecha de realización</label>
              <input type="date" class="form-control" id="maintenanceDate" value="${new Date().toISOString().split("T")[0]}">
            </div>
            <div class="mb-3">
              <label class="form-label">Kilometraje actual</label>
              <input type="number" class="form-control" id="maintenanceKm" value="${kilometrosVehiculo}" min="${kilometrosVehiculo}">
            </div>
			<div class="mb-3">
              <label class="form-label">Precio</label>
              <input type="number" class="form-control" id="precio" value="0">
            </div>

			<div class="mb-3">
              <label class="form-label">Taller / Comercio</label>
              <input type="text" class="form-control" id="tallerComercio" value="">
            </div>

            <div class="mb-3">
              <label class="form-label">Notas (opcional)</label>
              <textarea class="form-control" id="maintenanceNotes" rows="2" placeholder="Ej: Realizado en taller oficial"></textarea>
            </div>
          </div>
        `,
				showCancelButton: true,
				confirmButtonText: "Confirmar",
				cancelButtonText: "Cancelar",
				preConfirm: () => {
					return {
						date: document.getElementById("maintenanceDate").value,
						km: Number.parseInt(document.getElementById("maintenanceKm").value),
						notes: document.getElementById("maintenanceNotes").value,
						precio: Number.parseFloat(document.getElementById("precio").value),
						tallerComercio: document.getElementById("tallerComercio").value,
					};
				},
			});

			if (result.isConfirmed) {


				let adjuntosQS = "";

				const resultAdjunto = await Swal.fire({
					title: "¿Querés adjuntar el comprobante?",
					text: "Podés subir hasta 2 fotos.",
					icon: "question",
					showCancelButton: true,
					confirmButtonText: "Sí, adjuntar",
					cancelButtonText: "No, continuar",
					reverseButtons: true,
				});

				const quiereAdjuntar = resultAdjunto.isConfirmed;

				if (quiereAdjuntar) {
					const nombresAdjuntos = await AdjuntosService.openUploaderModal({
						token: user?.token,
						max: 2
					});

					// cerró la pantalla -> no enviar nada
					if (nombresAdjuntos === null) return;

					// canceló -> enviar sin adjuntos
					adjuntosQS = AdjuntosService.buildAdjuntosQuery(nombresAdjuntos);
				}


				const user = AuthService.getCurrentUser();
				const maintenanceData = {
					Dominio: Dominio,
					maintenanceTypeId: maintenanceTypeId,
					lastPerformedDate: result.value.date,
					lastPerformedKm: result.value.km,
					notes: result.value.notes,
					Precio: result.value.precio,
					Comercio: result.value.tallerComercio,
					proveedor: 0,
					calificacion: 0,
					comentarios: "",
				};
				await ApiService.post(`apiapp/VehiculoAgregarMantenimiento?Adjuntos=${encodeURIComponent(adjuntosQS)}`, maintenanceData, user?.token);

				await Swal.fire("¡Registrado!", "El mantenimiento ha sido registrado correctamente", "success");
				MaintenanceController.render();
			}
		} catch (error) {
			console.error("Error marking maintenance as done:", error);
			Swal.fire("Error", "No se pudo registrar el mantenimiento", "error");
		}
	},

	scheduleService: (vehicleId, maintenanceTypeId) => {
		Swal.fire({
			title: "Programar Servicio",
			text: "Esta función te permitirá programar un turno para el servicio",
			icon: "info",
			confirmButtonText: "Ir a Servicios",
			showCancelButton: true,
			cancelButtonText: "Cancelar",
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.hash = "services";
			}
		});
	},

	viewMaintenanceHistory: async (dominio) => {
		try {
			Swal.fire({
				title: 'Generando historial...',
				allowOutsideClick: false,
				didOpen: () => Swal.showLoading(),
			});

			const user = AuthService.getCurrentUser();
			const blob = await ApiService.postBlob('apiapp/historialvehiculopdf', { Dominio: dominio }, user?.token);

			Swal.close();

			const url = URL.createObjectURL(blob);
			window.open(url, '_blank');
			setTimeout(() => URL.revokeObjectURL(url), 60000);
		} catch (error) {
			console.error('Error al obtener historial PDF:', error);
			Swal.fire('Error', 'No se pudo generar el historial del vehículo', 'error');
		}
	},

	showCustomizeModal: async (dominio) => {
		const allTypes = MaintenanceController._maintenanceTypes;
		let hiddenIds = [...MaintenanceController.getHiddenMaintenances(dominio)];

		const buildRows = () => allTypes.map(type => {
			const isHidden = hiddenIds.includes(String(type.Id));
			return `<div class="d-flex align-items-center mb-2 p-2 border rounded">
				<i class="${type.Icono} me-2 text-primary"></i>
				<span class="flex-grow-1 text-start">${type.Nombre}</span>
				<button class="btn btn-sm ${isHidden ? "btn-outline-secondary" : "btn-outline-primary"} btn-toggle-mant"
						data-type-id="${type.Id}" title="${isHidden ? "Mostrar" : "Ocultar"}">
					<i class="fas ${isHidden ? "fa-eye-slash" : "fa-eye"}"></i>
				</button>
			</div>`;
		}).join("");

		const result = await Swal.fire({
			title: `<i class="fas fa-sliders me-2"></i>Personalizar<br><small class="text-muted">${dominio.toUpperCase()}</small>`,
			html: `<p class="text-muted small mb-3">Activá o desactivá los mantenimientos que querés ver para este vehículo.</p>
			       <div id="mantToggleList">${buildRows()}</div>`,
			showCancelButton: true,
			confirmButtonText: "Guardar",
			cancelButtonText: "Cancelar",
			didOpen: () => {
				document.getElementById("mantToggleList").addEventListener("click", (e) => {
					const btn = e.target.closest(".btn-toggle-mant");
					if (!btn) return;
					const typeId = String(btn.dataset.typeId);
					if (hiddenIds.includes(typeId)) {
						hiddenIds = hiddenIds.filter(id => id !== typeId);
					} else {
						hiddenIds.push(typeId);
					}
					const isNowHidden = hiddenIds.includes(typeId);
					btn.className = `btn btn-sm ${isNowHidden ? "btn-outline-secondary" : "btn-outline-primary"} btn-toggle-mant`;
					btn.querySelector("i").className = `fas ${isNowHidden ? "fa-eye-slash" : "fa-eye"}`;
					btn.title = isNowHidden ? "Mostrar" : "Ocultar";
				});
			},
		});

		if (result.isConfirmed) {
			MaintenanceController.saveHiddenMaintenances(dominio, hiddenIds);
			MaintenanceController.render();
		}
	},

};
